export interface Buyer {
  name: string
  city: string
  country: string
  flag: string
}

export const buyers: Buyer[] = [
  { name: 'Brandon K.', city: 'Houston, TX', country: 'United States', flag: '🇺🇸' },
  { name: 'Callum R.', city: 'Aberdeen', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Marc-André L.', city: 'Edmonton', country: 'Canada', flag: '🇨🇦' },
  { name: 'Josh W.', city: 'Newcastle, NSW', country: 'Australia', flag: '🇦🇺' },
  { name: 'Derek S.', city: 'Pittsburgh, PA', country: 'United States', flag: '🇺🇸' },
  { name: 'Liam O.', city: 'Sheffield', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Sarah M.', city: 'Hamilton, ON', country: 'Canada', flag: '🇨🇦' },
  { name: 'Riley T.', city: 'Perth', country: 'Australia', flag: '🇦🇺' },
  { name: 'Carlos V.', city: 'Baton Rouge, LA', country: 'United States', flag: '🇺🇸' },
  { name: 'Owen D.', city: 'Cardiff', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Kyle B.', city: 'Fort McMurray, AB', country: 'Canada', flag: '🇨🇦' },
  { name: 'Hannah P.', city: 'Gladstone, QLD', country: 'Australia', flag: '🇦🇺' },
]
